/* Zareen Jewels — product page: gallery, zoom, options (colour swatches + size pills), quantity,
   add to bag, sticky bar, share, rating link.
   A size option marked data-zjpd-required starts with nothing chosen; Add to bag asks for a size first. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const html = document.documentElement;

  const init = (root) => {
    if (!root || root.dataset.zjpdReady) return;
    root.dataset.zjpdReady = '1';

    let data = { variants: [] };
    try { data = JSON.parse(root.querySelector('[data-zjpd-json]').textContent); } catch (e) {}

    /* ---------- gallery ---------- */
    const slidesEl = root.querySelector('[data-zjpd-slides]');
    const slides = slidesEl ? [...slidesEl.children] : [];
    const thumbs = [...root.querySelectorAll('[data-zjpd-thumb]')];
    const current = root.querySelector('[data-zjpd-current]');
    const prev = root.querySelector('[data-zjpd-go="-1"]');
    const next = root.querySelector('[data-zjpd-go="1"]');
    let index = 0;

    const goTo = (i, smooth = true) => {
      if (!slidesEl || !slides[i]) return;
      slidesEl.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    const setIndex = (i) => {
      index = i;
      if (current) current.textContent = String(i + 1);
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        if (n === i) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else t.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    if (slidesEl && slides.length > 1) {
      let t = 0;
      slidesEl.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => setIndex(Math.round(slidesEl.scrollLeft / slidesEl.clientWidth)), 60);
      }, { passive: true });
      thumbs.forEach((b) => b.addEventListener('click', () => goTo(Number(b.dataset.zjpdThumb))));
      [prev, next].forEach((b) => b && b.addEventListener('click', () => goTo(Math.max(0, Math.min(slides.length - 1, index + Number(b.dataset.zjpdGo))))));
      setIndex(0);
    }
    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0) goTo(i);
    };

    /* ---------- zoom viewer ---------- */
    const zoom = root.querySelector('[data-zjpd-zoombox]');
    if (zoom) {
      const list = zoom.querySelector('[data-zjpd-zoomlist]');
      const items = [...list.children];
      const closeBtn = zoom.querySelector('[data-zjpd-zoom-close]');
      let returnTo = null;
      const open = (i, opener) => {
        returnTo = opener;
        items.forEach((it) => { const img = it.querySelector('img'); if (img && !img.src) img.src = img.dataset.src; it.classList.remove('is-zoomed'); });
        zoom.hidden = false;
        html.classList.add('zj-lock');
        const target = items.find((it) => it.dataset.index === String(i)) || items[0];
        requestAnimationFrame(() => {
          list.scrollTop = target ? target.offsetTop : 0;
          zoom.classList.add('is-open');
        });
        closeBtn.focus({ preventScroll: true });
      };
      const close = () => {
        zoom.classList.remove('is-open', 'is-used');
        html.classList.remove('zj-lock');
        setTimeout(() => { zoom.hidden = true; }, reduce ? 0 : 300);
        returnTo && returnTo.focus({ preventScroll: true });
      };
      root.querySelectorAll('[data-zjpd-zoom]').forEach((b) => b.addEventListener('click', () => open(b.dataset.zjpdZoom, b)));
      closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', (e) => {
        if (zoom.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); }
      });
      items.forEach((it) => {
        const img = it.querySelector('img');
        img.addEventListener('click', (e) => {
          zoom.classList.add('is-used');
          if (it.classList.contains('is-zoomed')) { it.classList.remove('is-zoomed'); return; }
          const r = img.getBoundingClientRect();
          const fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          it.classList.add('is-zoomed');
          requestAnimationFrame(() => {
            it.scrollLeft = fx * it.scrollWidth - it.clientWidth / 2;
            it.scrollTop = fy * it.scrollHeight - it.clientHeight / 2;
          });
        });
      });
    }

    /* ---------- variants ---------- */
    const form = root.querySelector('form.zjpd__form');
    const idInput = root.querySelector('[data-zjpd-variant]');
    const priceEl = root.querySelector('[data-zjpd-price]');
    const wasEl = root.querySelector('[data-zjpd-was]');
    const addBtn = root.querySelector('[data-zjpd-add]');
    const addLabel = root.querySelector('[data-zjpd-add-label]');
    const barPrice = root.querySelector('[data-zjpd-bar-price]');
    const barAdd = root.querySelector('[data-zjpd-bar-add]');
    const barLabel = root.querySelector('[data-zjpd-bar-label]');

    const groups = [...root.querySelectorAll('[data-zjpd-option]')];
    /* undefined = not chosen yet (only ever true for a required size) */
    const selected = groups.map((g) => {
      const on = g.querySelector('[aria-checked="true"]');
      if (on) return on.dataset.zjpdValue;
      if (g.hasAttribute('data-zjpd-required')) return undefined;
      const first = g.querySelector('[data-zjpd-value]');
      return first ? first.dataset.zjpdValue : undefined;
    });
    const complete = () => selected.every((x) => x !== undefined);
    const matches = (x, sel) => x.options.every((o, i) => sel[i] === undefined || o === sel[i]);

    const setBarLabel = (v) => {
      if (!barAdd) return;
      const available = v ? v.available : !barAdd.disabled;
      barAdd.disabled = !available;
      barLabel.textContent = !available ? 'Sold out' : complete() ? 'Add to bag' : 'Choose size';
    };

    const applyVariant = (v, moveGallery = true) => {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) { priceEl.textContent = v.price; priceEl.classList.toggle('is-sale', !!v.compare); }
      if (wasEl) { wasEl.textContent = v.compare || ''; wasEl.hidden = !v.compare; }
      const deal = root.querySelector('[data-zjpd-deal]');
      if (deal) {
        deal.hidden = !v.off;
        const o = deal.querySelector('[data-zjpd-off]'), sv = deal.querySelector('[data-zjpd-saving]');
        if (o) o.textContent = v.off || '';
        if (sv) sv.textContent = v.saving || '';
      }
      const tag = root.querySelector('[data-zjpd-tag]');
      if (tag) { tag.hidden = !v.off; const n = tag.querySelector('[data-zjpd-tag-off]'); if (n) n.textContent = `${v.off}%`; }
      const barWas = root.querySelector('[data-zjpd-bar-was]');
      if (barWas) { barWas.textContent = v.compare || ''; barWas.hidden = !v.compare; }
      if (barPrice) barPrice.textContent = v.price;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      setBarLabel(v);
      if (moveGallery) {
        const withMedia = v.media ? v : data.variants.find((x) => x.option1 === v.option1 && x.media);
        if (withMedia) showMedia(withMedia.media);
      }
      /* only write ?variant= once every option is chosen, so a reload never picks a size for the shopper */
      if (complete()) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    const markAvailability = () => {
      groups.forEach((g, gi) => {
        g.querySelectorAll('[data-zjpd-value]').forEach((btn) => {
          const trial = selected.slice(); trial[gi] = btn.dataset.zjpdValue;
          const ok = data.variants.some((x) => matches(x, trial) && x.available);
          btn.classList.toggle('is-out', !ok);
        });
      });
    };

    const clearNeed = (g) => {
      g.classList.remove('is-empty', 'is-missing', 'is-nudge');
      const need = g.querySelector('[data-zjpd-need]');
      if (need) need.hidden = true;
    };

    const pickValue = (g, btn, focus) => {
      const gi = groups.indexOf(g);
      g.querySelectorAll('[data-zjpd-value]').forEach((b) => { const on = b === btn; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
      if (focus) btn.focus();
      selected[gi] = btn.dataset.zjpdValue;
      const label = g.querySelector('[data-zjpd-opt-value]');
      if (label) label.textContent = btn.dataset.zjpdValue;
      clearNeed(g);
      let v = data.variants.find((x) => matches(x, selected) && x.available) || data.variants.find((x) => matches(x, selected));
      if (!v) {
        /* this value does not exist with the other choices: keep it, move the other chosen options to a match */
        v = data.variants.find((x) => x.options[gi] === selected[gi] && x.available) || data.variants.find((x) => x.options[gi] === selected[gi]);
        if (v) v.options.forEach((o, i) => {
          if (i === gi || selected[i] === undefined) return;
          selected[i] = o;
          const gg = groups[i];
          if (!gg) return;
          gg.querySelectorAll('[data-zjpd-value]').forEach((b) => { const on = b.dataset.zjpdValue === o; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
          const l = gg.querySelector('[data-zjpd-opt-value]'); if (l) l.textContent = o;
        });
      }
      applyVariant(v, gi === 0 || !!(v && v.media));
      markAvailability();
    };
    groups.forEach((g) => {
      const btns = [...g.querySelectorAll('[data-zjpd-value]')];
      btns.forEach((btn, i) => {
        btn.addEventListener('click', () => pickValue(g, btn));
        btn.addEventListener('keydown', (e) => {
          if (!['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
          e.preventDefault();
          const dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
          pickValue(g, btns[(i + dir + btns.length) % btns.length], true);
        });
      });
    });
    if (groups.length) markAvailability();
    setBarLabel();

    /* asks for the missing option; returns true when something is missing */
    const askForMissing = () => {
      const gi = selected.findIndex((x) => x === undefined);
      if (gi < 0) return false;
      const g = groups[gi];
      const need = g.querySelector('[data-zjpd-need]');
      if (need) need.hidden = false;
      g.classList.add('is-missing');
      g.classList.remove('is-nudge');
      void g.offsetWidth;
      g.classList.add('is-nudge');
      g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      const first = g.querySelector('[data-zjpd-value]:not(.is-out)') || g.querySelector('[data-zjpd-value]');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), reduce ? 0 : 350);
      return true;
    };

    /* ring size guide */
    const guide = root.querySelector('[data-zjpd-guide]');
    if (guide) {
      let back = null;
      const openG = (btn) => { back = btn; guide.hidden = false; html.classList.add('zj-lock'); requestAnimationFrame(() => requestAnimationFrame(() => guide.classList.add('is-open'))); guide.querySelector('.zjpd-guide__x').focus({ preventScroll: true }); };
      const closeG = () => { guide.classList.remove('is-open'); html.classList.remove('zj-lock'); setTimeout(() => { guide.hidden = true; }, reduce ? 0 : 300); back && back.focus({ preventScroll: true }); };
      root.querySelectorAll('[data-zjpd-guide-open]').forEach((b) => b.addEventListener('click', () => openG(b)));
      guide.querySelectorAll('[data-zjpd-guide-close]').forEach((b) => b.addEventListener('click', closeG));
      guide.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeG(); });
    }

    /* ---------- quantity ---------- */
    const qty = root.querySelector('.zjpd__qty-input');
    root.querySelectorAll('[data-zjpd-step]').forEach((b) => b.addEventListener('click', () => {
      const n = Math.max(1, Math.min(20, (parseInt(qty.value, 10) || 1) + Number(b.dataset.zjpdStep)));
      qty.value = n;
    }));
    if (qty) qty.addEventListener('change', () => { qty.value = Math.max(1, Math.min(20, parseInt(qty.value, 10) || 1)); });

    /* ---------- add to bag (Dawn cart notification) ---------- */
    const errorEl = root.querySelector('[data-zjpd-error]');
    const setBtn = (state, label) => {
      addBtn.classList.remove('is-loading', 'is-added');
      if (state) addBtn.classList.add(state);
      addLabel.textContent = label || (addBtn.disabled && !state ? 'Sold out' : 'Add to bag');
    };
    if (form && addBtn) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
        if (askForMissing()) return;
        errorEl.hidden = true;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const fd = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        setBtn('is-loading', 'Adding');
        addBtn.disabled = true;
        try {
          const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: fd,
          });
          const resData = await res.json();
          addBtn.disabled = false;
          if (resData.status) {
            errorEl.textContent = resData.description || resData.message || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
            setBtn();
            return;
          }
          setBtn('is-added', 'Added to bag');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zj-product', productVariantId: idInput.value, cartData: resData });
          document.dispatchEvent(new CustomEvent('zj:cart-added', { detail: resData }));
          if (cart && typeof cart.renderContents === 'function') cart.renderContents(resData);
          else window.location = (window.routes && window.routes.cart_url) || '/cart';
          setTimeout(() => setBtn(), 2200);
        } catch (err) {
          addBtn.disabled = false;
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          setBtn();
        }
      });
    }

    /* ---------- sticky bar ---------- */
    const bar = root.querySelector('[data-zjpd-bar]');
    const mqMobile = window.matchMedia('(max-width: 989px)');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      let past = false;
      const setBar = (on) => {
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        if (barAdd) barAdd.tabIndex = on ? 0 : -1;
        html.style.setProperty('--zj-float-lift', on && mqMobile.matches ? `${bar.offsetHeight}px` : '0px');
      };
      new IntersectionObserver(([e]) => {
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        setBar(past && mqMobile.matches);
      }).observe(addBtn);
      mqMobile.addEventListener && mqMobile.addEventListener('change', () => setBar(past && mqMobile.matches));
      if (barAdd) barAdd.addEventListener('click', () => {
        if (askForMissing()) return;
        if (!addBtn.disabled) form.requestSubmit ? form.requestSubmit() : addBtn.click();
      });
    }

    /* ---------- rating link → reviews further down the page ---------- */
    const rating = root.querySelector('[data-zjpd-reviews]');
    if (rating) {
      const target = () => document.querySelector('.zjl-words') || document.querySelector('.zjl');
      if (target()) {
        rating.hidden = false;
        rating.addEventListener('click', (e) => {
          const t = target();
          if (!t) return;
          e.preventDefault();
          t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }

    /* ---------- share ---------- */
    const share = root.querySelector('[data-zjpd-share]');
    if (share) {
      share.addEventListener('click', async () => {
        const url = window.location.href;
        const label = share.querySelector('[data-zjpd-share-label]');
        if (navigator.share) {
          try { await navigator.share({ title: share.dataset.title, url }); } catch (e) {}
          return;
        }
        try { await navigator.clipboard.writeText(url); label.textContent = 'Link copied'; }
        catch (e) { label.textContent = url; }
        setTimeout(() => { label.textContent = 'Share this piece'; }, 2400);
      });
    }
  };

  const boot = (scope) => scope.querySelectorAll('[data-zjpd]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
